
define(
	'Tavanoteam.RecentlyPurchased.RecentlyPurchased'
	, [
		'Tavanoteam.RecentlyPurchased.RecentlyPurchased.View'
	]
	, function (
		RecentlyPurchasedView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				var userProfileComponent = container.getComponent('UserProfile');

				userProfileComponent.getUserProfile().then(function (profile) {
					if (layout && profile.isloggedin) {
						layout.registerView('RecentlyPurchased', function () {
							return new RecentlyPurchasedView({ container: container });
						});
					}
				});

			}
		};
	});
